<template>
  <div class="password-change-container">
    <el-card class="password-card" shadow="never">
      <!-- 头部 -->
      <div slot="header" class="card-header">
        <span class="title">
          <i class="el-icon-lock"></i>
          修改密码
        </span>
        <span class="subtitle">为了账户安全，请定期更换密码</span>
      </div>

      <!-- 表单 -->
      <el-form
        ref="passwordForm"
        :model="formData"
        :rules="formRules"
        label-width="100px"
        class="password-form"
        @submit.native.prevent="handleSubmit"
      >
        <el-form-item label="原密码" prop="yuan_pass">
          <el-input
            v-model="formData.yuan_pass"
            type="password"
            placeholder="请输入当前登录密码"
            show-password
            autocomplete="current-password"
          />
        </el-form-item>

        <el-form-item label="新密码" prop="xin_pass">
          <el-input
            v-model="formData.xin_pass"
            type="password"
            placeholder="请输入新密码（6~20 位）"
            show-password
            autocomplete="new-password"
          />
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirm_pass">
          <el-input
            v-model="formData.confirm_pass"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            autocomplete="new-password"
          />
        </el-form-item>

        <el-form-item>
          <div class="form-actions">
            <el-button
              type="primary"
              :loading="submitting"
              @click="handleSubmit"
            >
              确认修改
            </el-button>
            <el-button @click="handleReset">重置</el-button>
          </div>
        </el-form-item>
      </el-form>

      <!-- 底部提示 -->
      <div class="password-tips">
        <i class="el-icon-info"></i>
        <span>密码修改后，请使用新密码重新登录</span>
      </div>
    </el-card>
  </div>
</template>

<script>
// 请根据项目实际路径调整请求工具
import request from '@/utils/request'

export default {
  name: 'PasswordChange',
  data () {
    // 自定义校验：确认密码与新密码一致
    const validateConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.formData.xin_pass) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      formData: {
        yuan_pass: '',
        xin_pass: '',
        confirm_pass: ''
      },
      formRules: {
        yuan_pass: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 1, message: '原密码不能为空', trigger: 'blur' }
        ],
        xin_pass: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '新密码长度应为 6~20 位', trigger: 'blur' }
        ],
        confirm_pass: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    // 根据 user_type 动态计算请求参数
    userInfo () {
      const userType = localStorage.getItem('user_type') || ''
      let userId = ''
      let aParam = ''

      switch (userType) {
        case 'caigou': // 采购
          userId = localStorage.getItem('crm_id') || ''
          aParam = 'caiedit'
          break
        case 'wholesaler': // 品牌方
          userId = localStorage.getItem('user_id') || ''
          aParam = 'brjxedit'
          break
        case 'retailer': // 经销商
          userId = localStorage.getItem('jx_id') || ''
          aParam = 'brjxedit'
          break
        default:
          // 兼容未知类型，默认尝试 user_id
          userId = localStorage.getItem('user_id') || ''
          aParam = 'caiedit'
          break
      }

      return { userId, aParam }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return

        // 额外校验：新密码不能与原密码相同
        if (this.formData.yuan_pass === this.formData.xin_pass) {
          this.$message.warning('新密码不能与原密码相同')
          return
        }

        const { userId, aParam } = this.userInfo
        if (!userId) {
          this.$message.error('未获取到用户信息，请重新登录')
          return
        }

        const params = {
          a: aParam,
          user_id: userId,
          yuan_pass: this.formData.yuan_pass,
          xin_pass: this.formData.xin_pass
        }

        this.submitting = true
        try {
          const res = await request.post('/index/pass_edit.php', params)
          if (res.code === '0' || res.code === 0) {
            this.$message.success(res.msg || '密码修改成功，请重新登录')
            this.handleReset()
            // 可选：跳转登录页
            // setTimeout(() => { this.$router.push('/login') }, 1500)
          } else {
            this.$message.error(res.msg || '修改失败，请稍后重试')
          }
        } catch (error) {
          console.error('[修改密码] 请求异常:', error)
          this.$message.error(error?.msg || '网络异常，请检查连接后重试')
        } finally {
          this.submitting = false
        }
      })
    },

    handleReset () {
      this.formData = {
        yuan_pass: '',
        xin_pass: '',
        confirm_pass: ''
      }
      this.$nextTick(() => {
        this.$refs.passwordForm && this.$refs.passwordForm.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password-change-container {
  max-width: 640px;
  margin: 0 auto;
  padding: 20px;
}

.password-card {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06) !important;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: #1d2129;
      display: flex;
      align-items: center;
      gap: 8px;

      .el-icon-lock {
        font-size: 22px;
        color: #409eff;
      }
    }

    .subtitle {
      font-size: 13px;
      color: #86909c;
    }
  }

  .password-form {
    padding: 20px 0 8px 0;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-input {
      max-width: 360px;
      width: 100%;
    }

    .el-input__inner {
      height: 42px;
      border-radius: 6px;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
      }
    }

    .form-actions {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;

      .el-button {
        min-width: 110px;
        height: 40px;
        border-radius: 6px;
        font-weight: 500;
      }
    }
  }

  .password-tips {
    padding-top: 16px;
    margin-top: 8px;
    border-top: 1px solid #f2f3f5;
    font-size: 13px;
    color: #86909c;
    display: flex;
    align-items: center;
    gap: 6px;

    .el-icon-info {
      color: #409eff;
      font-size: 15px;
    }
  }
}

// 响应式
@media (max-width: 520px) {
  .password-change-container {
    padding: 12px;
  }
  .password-card .password-form .el-input {
    max-width: 100%;
  }
  .password-card .password-form .form-actions .el-button {
    flex: 1;
    min-width: 90px;
  }
}
</style>
